// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class LoginWorkerDto extends APIModel {
    /**
    * User identifier
    */
    identifier: string;
    /**
    * Pin
    */
    pin: string;

    constructor(options?: APIModelOptions) {
        super(LoginWorkerDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "identifier", type: "string" },
            { name: "pin", type: "string" }
        ];
    }
}




